import { SVGProps } from 'react'

const PdfIconEmailPreview = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_33997_33207)">
        <path
          d="M11.6845 4.50297L8.62203 1.44047C8.58137 1.39985 8.53311 1.36765 8.48 1.34569C8.42689 1.32373 8.36997 1.31245 8.3125 1.3125H3.0625C2.83044 1.3125 2.60788 1.40469 2.44378 1.56878C2.27969 1.73288 2.1875 1.95544 2.1875 2.1875V11.8125C2.1875 12.0446 2.27969 12.2671 2.44378 12.4312C2.60788 12.5953 2.83044 12.6875 3.0625 12.6875H10.9375C11.1696 12.6875 11.3921 12.5953 11.5562 12.4312C11.7203 12.2671 11.8125 12.0446 11.8125 11.8125V4.8125C11.8125 4.75503 11.8013 4.69811 11.7793 4.645C11.7574 4.59189 11.7251 4.54363 11.6845 4.50297ZM8.75 2.80602L10.319 4.375H8.75V2.80602ZM10.9375 11.8125H3.0625V2.1875H7.875V4.8125C7.875 4.92853 7.92109 5.03981 8.00314 5.12186C8.08519 5.20391 8.19647 5.25 8.3125 5.25H10.9375V11.8125ZM9.1875 7.4375C9.1875 7.55353 9.14141 7.66481 9.05936 7.74686C8.97731 7.82891 8.86603 7.875 8.75 7.875H5.25C5.13397 7.875 5.02269 7.82891 4.94064 7.74686C4.85859 7.66481 4.8125 7.55353 4.8125 7.4375C4.8125 7.32147 4.85859 7.21019 4.94064 7.12814C5.02269 7.04609 5.13397 7 5.25 7H8.75C8.86603 7 8.97731 7.04609 9.05936 7.12814C9.14141 7.21019 9.1875 7.32147 9.1875 7.4375ZM9.1875 9.1875C9.1875 9.30353 9.14141 9.41481 9.05936 9.49686C8.97731 9.57891 8.86603 9.625 8.75 9.625H5.25C5.13397 9.625 5.02269 9.57891 4.94064 9.49686C4.85859 9.41481 4.8125 9.30353 4.8125 9.1875C4.8125 9.07147 4.85859 8.96019 4.94064 8.87814C5.02269 8.79609 5.13397 8.75 5.25 8.75H8.75C8.86603 8.75 8.97731 8.79609 9.05936 8.87814C9.14141 8.96019 9.1875 9.07147 9.1875 9.1875Z"
          fill="#737373"
        />
        <path
          d="M-0.888672 10.2773C-0.888672 9.72506 -0.440957 9.27734 0.111328 9.27734H2.11133V13.2773H0.111328C-0.440957 13.2773 -0.888672 12.8296 -0.888672 12.2773V10.2773Z"
          fill="#D65532"
        />
        <path
          d="M3.61133 9.27734C3.61133 9.0012 3.83519 8.77734 4.11133 8.77734H9.11133C9.38747 8.77734 9.61133 9.0012 9.61133 9.27734V13.2773C9.61133 13.5535 9.38747 13.7773 9.11133 13.7773H4.11133C3.83519 13.7773 3.61133 13.5535 3.61133 13.2773V9.27734Z"
          fill="white"
          stroke="#D65532"
        />
        <path
          d="M14.1113 10.2773C14.1113 9.72506 13.6636 9.27734 13.1113 9.27734H11.1113V13.2773H13.1113C13.6636 13.2773 14.1113 12.8296 14.1113 12.2773V10.2773Z"
          fill="#D65532"
        />
      </g>
      <defs>
        <clipPath id="clip0_33997_33207">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PdfIconEmailPreview
